import dayjs from "dayjs";

import { QueueByCompany, QueueCompany } from "./queue.types";

type GroupQueueByDaysParams = {
  response: QueueCompany[];
  arg: QueueByCompany["args"];
};
export function groupQueueByDays({ response, arg }: GroupQueueByDaysParams) {
  const dateFormat = arg?.dateFormat || "DD/MM";

  const responseByDays = response.reduce<QueueByCompany["result"]["grouped"]>((acc, queue) => {
    if (!("date" in queue) || !queue.date) return acc;

    const dateObj = dayjs(queue.date);
    const nowYear = dayjs().year();
    const dateYear = dateObj.year();
    const key = dateYear !== nowYear ? dateObj.format("DD/MM/YYYY") : dateObj.format(dateFormat);
    const existingEntry = acc.find((entry) => entry.date === key);

    if (existingEntry) {
      existingEntry.queues.push(queue);
      existingEntry.length = existingEntry.queues.length;
    } else {
      acc.push({
        date: key,
        length: 1,
        queues: [queue]
      });
    }

    return acc;
  }, []);

  return {
    original: response,
    grouped: responseByDays
  };
}

type BlockDriverActionsParams = {
  appointmentTime: string;
};
export function isDriverActionsBlocked({ appointmentTime }: BlockDriverActionsParams): boolean {
  const now = dayjs();
  const appointment = dayjs(appointmentTime);

  // Verifica se a data é válida; retorna false caso não seja
  if (!appointment.isValid()) {
    console.error("appointment is Invalid!");

    return true;
  }

  const minutes = appointment.diff(now, "minute");

  const SIX_HOURS_IN_MINUTES = 6 * 60; // 360 min
  const isDriverActionsBlocked = minutes <= SIX_HOURS_IN_MINUTES;

  return isDriverActionsBlocked;
}
